import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { useParams } from "react-router";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { Stage, Layer, Circle } from "react-konva";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//context
import { useAppContext } from "../../../../context/AppContext";
import { useMapContext } from "../../../../context/MapContext";
import { useContextSimulator } from "../Simulator/SimulatorContext";
//services
import { getMapData } from "../../../../services/GlobalRoles/getMapData";
import { getMapImage } from "../../../../services/GlobalRoles/getMapImage";
import { getGoogleMapImage } from "../../../../services/GlobalRoles/getGoogleMapImage";
import { getPublicMapLink } from "../../../../services/GlobalRoles/getPublicMapLink";
import usePermission from "../../../../hooks/usePermission";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { formatCurrency } from "../../../../utils/formatCurrency";

const EnterpriseMap = ({ empId, customAction, type }) => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  usePermission("20"); // Visualizar Mapa

  const refId = id !== undefined ? id : empId;

  const {
    visibleTooltip,
    setVisibleTooltip,
    selectedItem,
    tooltipPosition,
    panX,
    panY,
    zoom,
    setCurrentBlock,
    setCurrentLandIndex,
    currentIndex,
    data,
    setData,
    items,
    setItems,
    updateCursorPosition,
    mouseX,
    mouseY,
    imageSize,
    processMapData,
    tooltipReverse,
    tooltipEnd,
    handleTapCircle,
  } = useMapContext();

  const { setTestId } = useContextSimulator();

  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const [showToolTip, setShowToolTip] = useState(false);
  const scrollRef = useRef();
  const [circleSize, setCircleSize] = useState(8);
  const [closable, setClosable] = useState(false);
  const [canvasWidth, setCanvasWidth] = useState(null);
  const [modalLoading, setModalLoading] = useState(true);
  const [canvasHeight, setCanvasHeight] = useState(null);
  const [imageMap, setImageMap] = useState();

  const { data: mapImageMaps, isLoading: loadingImage } = useQuery({
    queryKey: [`map-image-${refId}-${type}`],
    queryFn: () => getMapImage(refId),
    retry: false,
    enabled: !!permissions?.includes("20")
  });

  const { data: mapImageGoogleMaps } = useQuery({
    queryKey: [`map-image-${id}`],
    queryFn: () => getGoogleMapImage(id),
    retry: false,
    enabled: !!permissions?.includes("21")
  });

  const { data: mapDataMaps, isLoading: loadingData } = useQuery({
    queryKey: [`map-data-${refId}`],
    queryFn: () => getMapData(refId),
    retry: false,
    enabled: !!permissions?.includes("20")
  });

  useEffect(() => {
    if (mapImageMaps) {
      const imagem = new Image();
      // if (type === "google") {
      //   imagem.src = mapImageGoogleMaps?.data;
      // } else {
      imagem.src = mapImageMaps.file;
      // }

      imagem.onload = () => {
        const { largura, altura } = imageSize(imagem);
        setCanvasWidth(largura);
        setCanvasHeight(altura);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapImageMaps]);

  useEffect(() => {
    async function fetchData() {
      // const [mapData, mapImage] = await Promise.all([
      //   getMapData(id),
      //   getMapImage(id),
      // ]);
      //      console.log(mapDataMaps);

      //      console.log(mapDataMaps);
      // navigate("/login");

      // console.log("Map Data: ", mapData);
      const { newItems, itemsToPosition } = processMapData(mapDataMaps);
      // Atualize os itens com os novos itens
      setItems([...newItems]);
      setData({ blocks: itemsToPosition });
      parseInt(mapDataMaps.ball_size) !== 0 &&
        setCircleSize(parseInt(mapDataMaps.ball_size));
      // console.log("Items to Position: ", itemsToPosition);

      if (mapImageMaps?.file && type !== "google") {
        // setActiveIndex(1);
        setImageMap(mapImageMaps.file);
        setClosable(true);
      } else if (mapImageGoogleMaps?.file && type === "google") {
        setImageMap(mapImageGoogleMaps.file);
        setClosable(true);
      } else {
        setClosable(false);
        return null;
      }
      setModalLoading(false);
    }

    if (!loadingImage && !loadingData) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapImageMaps, mapDataMaps, mapImageGoogleMaps]);

  useEffect(() => {
    // console.log("Data: ", data);
    if (data && data.length !== 0 && data.blocks.length > 0) {
      setCurrentBlock(data.blocks[currentIndex]);
      setCurrentLandIndex(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, currentIndex]);

  const navigation = [
    {
      template: () => (
        <Link
          to={`/enterprise/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Gestão de Vendas
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterprise/map/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Mapa do Empreendimento
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  async function getMapLink() {
    const notification = toast.loading("Por favor aguarde.");
    const sendData = {
      empId: refId,
      typeMap: "map",
    };
    const protocol = window.location.protocol;
    const baseUrl = window.location.host;

    console.log(protocol + baseUrl);
    const res = await getPublicMapLink(sendData);
    await navigator.clipboard.writeText(
      `${protocol}//${baseUrl}/publicMap/${res.success}`
    );
    toast.update(notification, {
      render: "O link foi copiado para sua área de transferência!",
      autoClose: 1000,
      theme: "colored",
      type: "success",
      isLoading: false,
    });
  }

  return (
    <div>
      {customAction !== "simulator" && type !== "google" && (
        <div className="row pb-4">
          <div className="col-md-8">
            <BreadCrumb
              model={navigation}
              home={home}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "16px",
              }}
            />
          </div>
          {permissions && permissions.includes("24") && ( //Copiar Link Publico
            <div className="col-md-4 my-auto text-end">
              <Button
                label="Copiar Link"
                icon="fa-solid fa-copy"
                size="small"
                onClick={() => getMapLink()}
              // className="w-100"
              />
            </div>
          )}
        </div>
      )}

      {visibleTooltip && selectedItem && (
        <div
          style={{
            position: "absolute",
            zIndex: "100",
            minHeight: "100px",
            pointerEvents: "none",
          }}
          className="map-instruction-desktop"
        >
          <div
            style={{
              position: "relative",
              left: tooltipPosition.left - 20, // Ajuste horizontal conforme necessário
              // com imagem: top - 280
              top: tooltipPosition.top - 150, // Ajuste o deslocamento vertical conforme necessário
              fontSize: zoom > 1 ? "6px" : "16px",
            }}
            className="bg-white px-2 py-1 rounded"
          >
            <div className="d-flex flex-column">
              <div className="d-flex">
                <p className="mt-2 ms-2">
                  {nomenclature[0].value}/{nomenclature[1].value}{" "}
                  <b>{selectedItem.land}</b>{" "}
                </p>
                <div
                  onClick={() => setVisibleTooltip(false)}
                  style={{ cursor: "pointer", pointerEvents: "auto" }}
                >
                  <i
                    className="fa-regular text-danger fa-circle-xmark ms-4"
                    style={{ marginTop: "8px", fontSize: "20px" }}
                  ></i>
                </div>
              </div>
              <div className="d-flex flex-column align-items-center mb-2">
                <div className="d-flex">
                  <h6 className="mx-2">M²: {selectedItem.m2}</h6>
                  {selectedItem.color === "#33FF3C" && (
                    <h6 className="mx-2">
                      Valor: {formatCurrency(selectedItem.value)}
                    </h6>
                  )}
                </div>
                {permissions && permissions.includes("87") && (
                  <div className="mt-2">
                    <Button
                      label={
                        selectedItem.color === "#33FF3C"
                          ? "Fazer Simulação"
                          : `${nomenclature[1].value} indisponível`
                      }
                      disabled={selectedItem.color !== "#33FF3C"}
                      onClick={() =>
                        navigate(`/enterprise/simulator/${selectedItem.id}`, {
                          state: { empId: id },
                        })
                      }
                      style={{ pointerEvents: "auto" }}
                    />
                  </div>
                )}
              </div>
            </div>
            {/* {window.innerWidth >= 992 && (
              <div
                style={{
                  position: "absolute",
                  top: !tooltipReverse ? "100%" : "", // Posicione o triângulo em relação à parte inferior do elemento pai
                  bottom: tooltipReverse ? "100%" : "",
                  left: tooltipEnd ? "90%" : "22px", // Centralize o triângulo horizontalmente
                  transform: tooltipReverse
                    ? "translateX(-50%) rotate(180deg)"
                    : "translateX(-50%)", // Centralize o triângulo horizontalmente
                  width: "0",
                  height: "0",
                  borderLeft: "10px solid transparent",
                  borderRight: "10px solid transparent",
                  borderTop: "10px solid white", // A cor do triângulo
                }}
                className="pin-map"
              />
            )} */}
          </div>
        </div>
      )}

      {loadingImage && loadingData && imageMap === undefined ? (
        <Skeleton width="100%" height="100vh" />
      ) : (
        <>
          {type !== "google" ? (
            <div className="enterprise--map">
              <TransformWrapper
                panning={{ wheelPanning: true }}
              // centerOnInit={true} 
              >
                <TransformComponent>
                  {window.innerWidth >= 992 ? (
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        transform: `scale(${zoom}) translate(${panX}px, ${panY}px)`,
                      }}
                    >
                      {imageMap !== undefined ? (
                        <img
                          src={imageMap}
                          alt="map"
                          style={{
                            width: canvasWidth,
                            height: canvasHeight,
                            position: "absolute",
                            objectFit: "contain",
                          }}
                          name={"map"}
                        />
                      ) : (
                        <Skeleton width="100%" height="100vh" />
                      )}

                      <Stage
                        width={canvasWidth}
                        height={canvasHeight}
                        onMouseMove={updateCursorPosition}
                        onMouseEnter={() => setShowToolTip(true)}
                        onMouseLeave={() => setShowToolTip(false)}
                      >
                        <Layer>
                          {items.map((item, i) => (
                            <Circle
                              key={i}
                              name={item.id.toString()}
                              x={item.x}
                              y={item.y}
                              radius={parseInt(circleSize)} // Tamanho fixo dos círculos
                              fill={item.color}
                              onPointerClick={(e) => handleTapCircle(item, e, { x: 0, y: 0 }, customAction, setTestId)}
                            />
                          ))}
                        </Layer>
                      </Stage>
                    </div>
                  ) : (
                    <div style={{ overflowX: "scroll" }} ref={scrollRef}>
                      {canvasWidth && items && (
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            transform: `scale(${zoom}) translate(${panX}px, ${panY}px)`,
                          }}
                        >
                          <img
                            src={imageMap}
                            alt="map"
                            style={{
                              width: canvasWidth,
                              height: canvasHeight,
                              position: "absolute",
                              objectFit: "contain",
                            }}
                            name={"map"}
                          />
                          <Stage
                            width={canvasWidth}
                            height={canvasHeight}
                            onMouseEnter={() => setShowToolTip(true)}
                            onMouseLeave={() => setShowToolTip(false)}
                          >
                            <Layer>
                              {items.map((item, i) => (
                                <Circle
                                  key={i}
                                  name={item.id}
                                  draggable
                                  x={item.x}
                                  y={item.y}
                                  radius={parseInt(circleSize)} // Tamanho fixo dos círculos
                                  fill={item.color}
                                  onPointerClick={(e) => handleTapCircle(item, e, { x: 0, y: 0 }, customAction, setTestId)}
                                />
                              ))}
                            </Layer>
                          </Stage>
                        </div>
                      )}
                    </div>
                  )}
                </TransformComponent>
              </TransformWrapper>
            </div>
          ) : (
            <div className="enterprise--map">
              {window.innerWidth >= 992 ? (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    transform: `scale(${zoom}) translate(${panX}px, ${panY}px)`,
                  }}
                >
                  {imageMap !== undefined ? (
                    <img
                      src={imageMap}
                      alt="map"
                      style={{
                        width: canvasWidth,
                        height: canvasHeight,
                        position: "absolute",
                        objectFit: "contain",
                      }}
                      name={"map"}
                    />
                  ) : (
                    <Skeleton width="100%" height="100vh" />
                  )}

                  <Stage
                    width={canvasWidth}
                    height={canvasHeight}
                    onMouseMove={updateCursorPosition}
                    onMouseEnter={() => setShowToolTip(true)}
                    onMouseLeave={() => setShowToolTip(false)}
                  >
                    <Layer>
                      {items.map((item, i) => (
                        <Circle
                          key={i}
                          name={item.id.toString()}
                          x={item.x}
                          y={item.y}
                          radius={parseInt(circleSize)} // Tamanho fixo dos círculos
                          fill={item.color}
                          onPointerClick={(e) => handleTapCircle(item, e, { x: 0, y: 0 }, customAction, setTestId)}
                        />
                      ))}
                    </Layer>
                  </Stage>
                </div>
              ) : (
                <div style={{ overflowX: "scroll" }} ref={scrollRef}>
                  {canvasWidth && items && (
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        transform: `scale(${zoom}) translate(${panX}px, ${panY}px)`,
                      }}
                    >
                      <img
                        src={imageMap}
                        alt="map"
                        style={{
                          width: canvasWidth,
                          height: canvasHeight,
                          position: "absolute",
                          objectFit: "contain",
                        }}
                        name={"map"}
                      />
                      <Stage
                        width={canvasWidth}
                        height={canvasHeight}
                        onMouseEnter={() => setShowToolTip(true)}
                        onMouseLeave={() => setShowToolTip(false)}
                      >
                        <Layer>
                          {items.map((item, i) => (
                            <Circle
                              key={i}
                              name={item.id}
                              draggable
                              x={item.x}
                              y={item.y}
                              radius={parseInt(circleSize)} // Tamanho fixo dos círculos
                              fill={item.color}
                              onPointerClick={(e) => handleTapCircle(item, e, { x: 0, y: 0 }, customAction, setTestId)}
                            />
                          ))}
                        </Layer>
                      </Stage>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default EnterpriseMap;
